/**
 * KPI numbers from POST /getBasicFinancials (agents.futurecommission, agents.possibleprofit).
 */

export function parseBasicFinancialsAmount(value, label) {
  if (value === null || value === undefined) {
    return { n: 0, fallbackReason: `${label}_nullish` };
  }
  const x = Number(value);
  if (!Number.isFinite(x)) {
    return { n: 0, fallbackReason: `${label}_non_finite` };
  }
  return { n: x, fallbackReason: null };
}

export function logFutureCommissionFeTrace(payload) {
  if (typeof import.meta !== "undefined" && import.meta.env?.DEV) {
    console.log("[FUTURE_COMMISSION_FE_TRACE]", payload);
  }
}
